<kt-building-section [readonly]="readonly" [buildingId]="acBuilding.infoSection.building_id" [(centerLat)]="centerLat"
    [(centerLng)]="centerLng" (centerChange)="onCenterChange($event)" (picChange)="onPicChange($event)"
    (buildingSelected)="onBuildingChange($event)" (buildingCleared)="onBuildingCleared()"
    [buildingPictures]="buildingPictures" [buildingPicturePath]="buildingPicturePath" [parent]="parent"
    [showPicSection]="false" [data]="acBuilding.infoSection" [lowLevelTitle]="'1 - General Info'"
    [building$]="building$"
    [unitOfAreaMeasurement]="unitOfAreaMeasurementId$|async"></kt-building-section>

<div class="row" style="margin-top: -1.5rem;">
    <div class="col-12">
        <div class="d-flex align-items-center" style="gap: 0.2rem;">
            <button type="button" mat-icon-button color="primary" (click)="onAddConstructionCategory()">
                <mat-icon>add_circle</mat-icon>
            </button>
            <span class="font-italic font-weight-bold">
                Add a construction category
            </span>
        </div>
    </div>
</div>
<div class="row">
    <ng-container *ngFor="let group of constructionCategoryFormArray.controls; let i = index">
        <div class="col-6" [formGroup]="group">
            <div class="row">
                <div class="col-10">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput [placeholder]="'Construction category ' + (i + 1) + ' Title'" formControlName="title" />
                    </mat-form-field>
                </div>
                <div class="col-2">
                    <button type="button" mat-icon-button color="warn" (click)="onRemoveConstructionCategory(i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <mat-form-field class="mat-form-field-fluid">
                        <textarea matInput formControlName="description" [placeholder]="'Construction category ' + (i + 1) + ' description'"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<div class="row mt-5">
    <div class="col-12">
        <h5 class="font-weight-bold">Building Unit Breakdown</h5>
    </div>
</div>
<div class="row mt-2">
    <input #buildingUnitBreakdownFileInput type="file" hidden (change)="onUploadUnitBreakdown($event)" accept=".csv" />
    <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
        <button type="button" mat-raised-button color="primary" (click)="onClickUploadUnitBreakdown()">
            Upload CSV
        </button>
        <ng-container *ngIf="buildingUnitBreakdownFile$|async as viewModel">
            <div class="d-flex align-items-center" style="gap: 0.5rem;">
                <button type="button" mat-icon-button color="primary" *ngIf="viewModel.isUploaded">
                    <mat-icon>remove_red_eye</mat-icon>
                </button>
                <div>
                    <span class="font-weight-bold">File name: </span>
                    <ng-container *ngIf="viewModel.file">
                        <span style="color: green">{{viewModel.file.display_name}}</span>
                    </ng-container>
                    <ng-container *ngIf="!viewModel.file">
                        <span style="color: red">N/A</span>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row mt-2">
    <div class="col-12">
        <span class="font-italic">
            Please upload the CSV file of your building unit breakdown. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process
        </span>
    </div>
</div>

<div class="row mt-10">
    <div class="col-12">
        <h5 class="font-weight-bold">Building Accommodation Layout</h5>
    </div>
</div>
<div class="row mt-2">
    <input #buildingAccommodationLayoutFileInput type="file" hidden (change)="onUploadAccommodationLayout($event)" accept=".csv" />
    <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
        <button type="button" mat-raised-button color="primary" (click)="onClickUploadAccommodationLayout()">
            Upload CSV
        </button>
        <ng-container *ngIf="buildingAccommodationLayoutFile$|async as viewModel">
            <div class="d-flex align-items-center" style="gap: 0.5rem;">
                <button type="button" mat-icon-button color="primary" *ngIf="viewModel.isUploaded">
                    <mat-icon>remove_red_eye</mat-icon>
                </button>
                <div>
                    <span class="font-weight-bold">File name: </span>
                    <ng-container *ngIf="viewModel.file">
                        <span style="color: green">{{viewModel.file.display_name}}</span>
                    </ng-container>
                    <ng-container *ngIf="!viewModel.file">
                        <span style="color: red">N/A</span>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row mt-2">
    <div class="col-12">
        <span class="font-italic">
            Please upload the CSV file of your building accommodation layout. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process
        </span>
    </div>
</div>

<div *ngIf="isComplexForm">
    <div class="form-group kt-form__group row section-margin-top-60">
        <div class="col-lg-12 mb-0 multimedia-header item-center ">
            <h5 class="my-3 text-black text-uppercase">
                2 - Land Parcel
            </h5>
        </div>
        <div class="col-lg-12">
            <app-parcel-identification
                [form]="parcelIdentificationForm"
                [centerLat]="centerLat"
                [centerLng]="centerLng"
                [landAreaLowLevelTitle]="'3 - Land Area'" 
                [coordinatePoints]="coordinatePoints$|async"
                [landAreas]="landAreas$|async"
                (coordinatePointsChange)="onCoordinatePointsChange($event)"
                (landAreasChange)="onLandAreasChange($event)"
            ></app-parcel-identification>
            <!-- <kt-parcel-identifaction-section 
                [readonly]="readonly" 
                [landAreaLowLevelTitle]="'3 - Land Area'" 
                [centerLat]="centerLat"
                [centerLng]="centerLng" 
                [data]="parcelIdentificationData"
                (checked)="onParcelChecked($event)">
            </kt-parcel-identifaction-section> -->
        </div>
    </div>
    <div class="form-group kt-form__group row section-margin-top-60">
        <div class="col-lg-12 mb-0 multimedia-header item-center ">
            <h5 class="my-3 text-black text-uppercase">
                {{hasParcelChecked ? '4' : '3'}} - Common areas, Services and Infrastructures
            </h5>
        </div>
        <div class="col-lg-12">
            <kt-services-and-infrastructures 
                [readonly]="readonly" 
                [propertySubTypeID]="0" 
                [isComplexForm]="isComplexForm"
                [serviceAndInfraData]="serviceAndInfraData">
            </kt-services-and-infrastructures>
        </div>
    </div>

    <div class="form-group kt-form__group row section-margin-top-60">
        <div class="col-lg-12 mb-0 multimedia-header item-center ">
            <h5 class="my-3 text-black text-uppercase">
                {{hasParcelChecked ? '5' : '4'}} - External Aspect
            </h5>
        </div>
        <div class="col-lg-12">
            <kt-external-aspects [readonly]="readonly" [propertySubTypeID]="0" [externalAspectData]="externalAspectData">
            </kt-external-aspects>
        </div>
    </div>

    <div class="form-group kt-form__group row section-margin-top-60">
        <div class="col-lg-12 mb-0 multimedia-header item-center ">
            <h5 class="my-3 text-black text-uppercase">
                {{hasParcelChecked ? '6' : '5'}} - Internal Aspect
            </h5>
        </div>
        <div class="col-lg-12">
            <kt-building-internal-aspects [readonly]="readonly" [data]="internalAspectData"></kt-building-internal-aspects>
        </div>
    </div>

    <div class="form-group kt-form__group row section-margin-top-60">
        <div class="col-lg-12 mb-0 multimedia-header item-center ">
            <h5 class="my-3 text-black text-uppercase">
                {{hasParcelChecked ? '7' : '6'}} - Grounds
            </h5>
        </div>
        <div class="col-lg-12">
            <kt-ac-grounds [readonly]="readonly" [isComplexForm]="isComplexForm" [propertySubTypeID]="0" [initData]="grounds"></kt-ac-grounds>
        </div>
    </div>

    <div class="form-group row section-margin-top-60">
        <div class="col-lg-12">
            <kt-ac-size [readonly]="readonly" [hideTitle]="true" [lowLevelTitle]="(hasParcelChecked ? '8' : '7') + ' - Sizes'" [sizesSubject]="sizesSubject"
                [assetClassType]="'0'"></kt-ac-size>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <h5 class="font-weight-bold">Floor area measurements</h5>
    </div>
</div>
<div class="row mt-2">
    <div class="col-12">
        <mat-form-field class="mat-form-field-fluid">
            <textarea matInput [formControl]="floorAreaMeasurementCommentControl" placeholder="Floor area measurement comment"></textarea>
        </mat-form-field>
    </div>
</div>
<div class="row mt-2">
    <div class="col-12">
        <span class="font-italic">
            Please upload the CSV file of your floor measurement. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process
        </span>
    </div>
</div>
<ng-container *ngFor="let group of floorAreaMeasurementFormArray.controls; let i = index">
    <div class="row mt-2" [formGroup]="group">
        <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
            <button type="button" mat-raised-button color="primary" (click)="onClickUploadFloorAreaMeasurement(i)">
                Upload CSV
            </button>
            <div class="d-flex align-items-center" style="gap: 0.5rem;">
                <button type="button" mat-icon-button color="primary" *ngIf="group.controls.name.value">
                    <mat-icon>remove_red_eye</mat-icon>
                </button>
                <div>
                    <span class="font-weight-bold">File name: </span>
                    <ng-container *ngIf="group.controls.name.value">
                        <span style="color: green">{{group.controls.display_name.value}}</span>
                    </ng-container>
                    <ng-container *ngIf="!group.controls.name.value">
                        <span style="color: red">N/A</span>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="col-12 mt-2">
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput formControlName="title"
                            [placeholder]="'Table ' + (i + 1) + ' Title'" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-select formControlName="property_sub_type_id"
                            placeholder="Property Sub-type">
                            <mat-option *ngFor="let option of propertySubTypes$|async" [value]="option.id">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <ng-container *ngIf="measurementStandards$|async as ms">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select formControlName="measurement_standard_id" placeholder="Measurement Standard">
                                <mat-option *ngFor="let option of filterMeasurementStandards(i, ms)" [value]="option.id">
                                    {{ option.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-1">
        <div class="col-1">
            <button type="button" mat-icon-button color="primary" (click)="onAddFloorAreaMeasurement()">
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
        <div class="col-1" *ngIf="i !== 0">
            <button type="button" mat-icon-button color="warn" (click)="onRemoveFloorAreaMeasurement(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
</ng-container>